import { Button } from "@svea/design-system-components-react";
import {
	ButtonGroup,
	Dialog,
	Markdown,
	openBankIdApp,
	useSigning,
	useText,
} from "@sveabank/cc-common";
import QrCode from "../../components/qr-code";

const SigningModal = () => {
	const [t, texts] = useText();
	const { isSigning, onCancel, qrCode, bankIdToken } = useSigning();

	return (
		<Dialog
			isDismissable={false}
			size="small"
			center
			isOpen={isSigning}
			heading={t(texts.signPage.signWithBankId)}
			icon="bankid"
		>
			<Dialog.Content>
				<Markdown allowParagraphs>{t(texts.signPage.bankIdHelp)}</Markdown>
				<QrCode qrCode={qrCode} />
			</Dialog.Content>
			<ButtonGroup>
				<Button
					onPress={() => {
						if (bankIdToken) openBankIdApp(bankIdToken);
					}}
					width="full"
				>
					{t(texts.signPage.openBankIdApp)}
				</Button>
				<div className="text-center">
					<Button variant="plain" width="full" onPress={onCancel ? onCancel : undefined}>
						{t(texts.common.abort)}
					</Button>
				</div>
			</ButtonGroup>
		</Dialog>
	);
};

export default SigningModal;
